module.exports = __webpack_public_path__ + "media/site/images/icons/bulb-icon-d493800a4d301370e4f5fdd48c112d36.svg";